import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
    sendForgotPassword (email) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}Account/resetemail?email=${email}`, AUTH_HEADERS())
    },
    resetPassword (data) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}Account/submitToken`, data, AUTH_HEADERS())
    },
    resetPasswordAdmin (data) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}Account/resetPasswordAdmin`, data, AUTH_HEADERS())
    }
}
